<template>
  <div v-loading="$wait.waiting(_uid)" class="company-people card">
    <div class="card w-full">
      <div class="card-content">
        <div class="mt-s">
          <div class="mb-5 w-full">
            <fieldset>
              <div class="form-group">
                <input
                  v-model="searchQuery"
                  type="search"
                  class="form-control form-search"
                  placeholder="Type to find what you are looking for"
                  aria-controls="datatables"
                  autofocus
                />
              </div>
            </fieldset>
          </div>

          <div>
            <el-table
              class="table-striped table-with-tooltip"
              :data="queriedData"
              border
              style="width: 100%"
            >
              <el-table-column type="expand">
                <template #default="props">
                  <div class="flex flex-row expand-children mb-4">
                    <div class="flex-1">
                      <b>Roles</b>

                      <div
                        v-for="(role, index) in props.row.acl.roles"
                        :key="index"
                        class="flex flex-row"
                      >
                        {{ role }}
                      </div>
                    </div>

                    <div class="flex-1">
                      <b>Permissions</b>

                      <div
                        v-for="(permission, index) in props.row.acl.permissions"
                        :key="index"
                        class="flex flex-row"
                      >
                        {{ permission }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                show-overflow-tooltip
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              />
            </el-table>
          </div>

          <!-- <div class="flex justify-between items-center">
            <div>
              <p class="category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>

            <p-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            />

            <div>
              <el-select
                v-model="pagination.perPage"
                class="select-default"
                placeholder="Per page"
              >
                <el-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  class="select-default"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _get from "lodash.get";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
//import PPagination from "@components/UIComponents/Pagination.vue";
import tableConfig from "@providers/table";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

export default {
  components: {
    //PPagination,
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "id",
          label: "Id",
          minWidth: 40,
        },
        {
          prop: "username",
          label: "Username",
          minWidth: 180,
        },
        {
          prop: "fullName",
          label: "Name",
          minWidth: 180,
        },
      ],

      ...tableConfig.data,
    };
  },
  computed: {
    users() {
      return _get(this, "$store.state.companyUser.usersAcl", []);
    },
    tableData() {
      return this.users;
    },
    isLoading() {
      return _get(this, "$store.state.companyUser.isLoading");
    },
    ...tableConfig.computed,
  },
  async mounted() {
    try {
      this.$store.commit("companyUser/setLoading", true, { root: true });

      await this.$store.dispatch("companyUser/getUsersAcl");
    } catch (error) {
      console.error(error);
      return this.$notify({
        message:
          error.readableError || "Error retrieving users, try again later",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "danger",
      });
    } finally {
      this.$store.commit("companyUser/setLoading", false, { root: true });
    }
  },
};
</script>

<style></style>
